import { QueryFunctionContext } from 'react-query';

import { ContentStoreSuggestionsService } from 'src/services/Suggestions';
import { DEFAULT_LIMIT } from 'src/constants';

export const QUERY_KEY = 'categorySuggestions';

export const queryCategorySuggestions = (
    context: QueryFunctionContext<App.Suggestions.QueryKey>,
): Promise<Models.ContentStoreApi.V3.SourcedCategory[]> => {
    const { queryKey: [, accessToken, search] } = context;

    return ContentStoreSuggestionsService.getCategorySuggestions(
        accessToken,
        search.ids,
        DEFAULT_LIMIT,
    );
};
